module.exports = __webpack_public_path__ + "img/news1.5e42887a.png";